query PlatformPagesAutocomplete(
  $input: String = ""
  $value: [ID!] = []
  $filter: AutocompletePlatformPagesFilterInput
) {
  autocomplete: autocompletePlatformPages(
    input: $input
    value: $value
    filter: $filter
  ) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
